import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'

type selectOption = {
    label: string
    value: number
}

type Props = {
    name: string
    label: string
    options: selectOption[]
    required?: boolean
    disabled?: boolean
}

const AutocompleteSelect = ({
                                name='',
                                label='',
                                options=[],
                                required = false,
                                disabled = false
                            }: Props) => {
    const { control } = useFormContext()

    return (
        <Controller
            control={control}
            name={name}
            rules={{ required: required }}
            defaultValue={null}
            render={({ field: { onChange, value, ...field } }) => {
                const selectedOption = options.find(option => option.value === value) || null

                return (
                    <Autocomplete<selectOption>
                        {...field}
                        value={selectedOption}
                        disabled={disabled}
                        options={options}
                        filterOptions={(opts, state) => {
                            const inputValue = state.inputValue.toLowerCase()
                            return opts.filter((option) =>
                                option.label.toLowerCase().includes(inputValue)
                            )
                        }}
                        getOptionLabel={(option: selectOption) => option.label}
                        isOptionEqualToValue={(option: selectOption, val: selectOption) =>
                            option.value === val.value
                        }
                        onChange={(_, newValue: selectOption | null) => {
                            onChange(newValue?.value || null)
                        }}
                        renderOption={(props, option: selectOption) => (
                            <li {...props} key={option.value}>
                                {option.label}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} label={label} required={required} />
                        )}
                    />
                )
            }}
        />
    )
}

export default AutocompleteSelect